import { THEME_NAMES } from 'themes';
import { useThemeName } from './use-theme';

export function useXy(): boolean {
  const theme = useThemeName();
  return theme === THEME_NAMES.XY;
}
